import React from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import { handleRegister, handleGetTotp, reset } from '../../register/register.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { plugin, LINK_TERM_OF_USE, PLUGIN } from 'app/config/constants';

export interface IAuthAddTokenProps extends StateProps, DispatchProps {
  modalShow: boolean;
  handleClose: Function;
}
export class AuthAddToken extends React.Component<IAuthAddTokenProps> {
  componentDidMount() {
    // window['checkPlugin']();
    this.props.handleGetTotp();
  }

  registerUSBToken = (event, values) => {
    const totp = this.props.totp;
    if (totp) {
      Storage.session.set('totp', totp.message);
      //Storage.session.set('userType', values.userTypeToken);
      Storage.session.set('type', 'Token');
      window['exc_sign_msg'](totp.message);
    }
    event.preventDefault();
  };
  handleToggle = () => {
    this.props.handleClose();
  };

  render() {
    let centered = window.location === window.parent.location ? 'modal-dialog modal-dialog-centered' : 'modal-dialog';
    return (
      <div>
        <Modal
          className="hide-border-bottom-modal"
          isOpen={this.props.modalShow}
          toggle={this.handleToggle}
          backdrop="static"
          centered={window.location === window.parent.location}
        >
          <ModalHeader toggle={this.handleToggle} />
          <ModalBody className="padding-modal-body">
            <Row className="justify-content-center bodyModal">
              <Col md="12">
                <AvForm id="register-form-token" onValidSubmit={this.registerUSBToken}>
                  <div className="huong-dan-dk-sim">
                    {/* <div className="title">Hướng dẫn đăng ký bằng USB Token</div> */}
                    <div className="steps">
                      <div className="li">
                        <p>
                          Tải về và cài đặt công cụ ký điện tử trên Windows{' '}
                          <a className="style-link" href={PLUGIN.WINDOWS_OS}>
                            tại đây
                          </a>{' '}
                          & MacOS{' '}
                          <a className="listyle-linknk" href={PLUGIN.MAC_OS}>
                            tại đây
                          </a>
                          .
                        </p>
                      </div>
                      <label style={{ marginTop: '20px' }}>
                        <Translate contentKey="register.term1" />
                        <a target="_blank">
                          <Translate contentKey="register.term2" />
                        </a>
                        <Translate contentKey="register.term3" />
                      </label>
                    </div>
                  </div>
                  <Button className="btn-register" type="submit" block>
                    <Translate contentKey="register.form.button">Register</Translate>
                  </Button>
                </AvForm>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  totp: storeState.register.totp,
  config: storeState.applicationProfile.config
});

const mapDispatchToProps = { handleGetTotp };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthAddToken);
